export default __webpack_public_path__ + "static/icomoon-c8bd81aa4de0669244acc381af6b1c6e.ttf";